import React, { useState, useMemo } from "react";
import useSWR from "swr";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import Faq from "./Faq";
import FaqTopic from "./FaqTopic";
import FaqSearch from "./FaqSearch";

const API_URL = `${process.env.REACT_APP_API_FOLDER}get_faqs/`;
const API_TOKEN = process.env.REACT_APP_API_TOKEN;

const fetcher = (url) =>
  fetch(url, { headers: { "X-API-TOKEN": API_TOKEN } })
    .then((res) => {
      if (!res.ok) throw new Error(`Network response was not ok: ${res.status}`);
      return res.json();
    });

function FaqWrapper() {
  const { data: allFaqs = [], error, isLoading } = useSWR(API_URL, fetcher);

  const [searchTerm, setSearchTerm] = useState("");
  const [subjectFilter, setSubjectFilter] = useState("all");

  // Compute filtered FAQs regardless of render path
  const filtered = useMemo(() => {
    return allFaqs.filter((item) => {
      const text = (item.question + " " + item.answer).toLowerCase();
      if (searchTerm && !text.includes(searchTerm.toLowerCase())) return false;

      if (subjectFilter !== "all") {
        // split on comma and trim whitespace
        const subjects = item.subject
          .split(",")
          .map((s) => s.trim().toLowerCase());
        if (!subjects.includes(subjectFilter.toLowerCase())) return false;
      }

      return true;
    });
  }, [allFaqs, searchTerm, subjectFilter]);

  // Skeleton loading state
  if (isLoading) {
    return (
      <div className="faq-wrapper pt-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              {Array(5).fill().map((_, idx) => (
                <div key={idx} className="mb-4">
                  <Skeleton height={30} width="80%" style={{ marginBottom: "0.5rem" }} />
                  <Skeleton count={2} style={{ marginBottom: "1rem" }} />
                </div>
              ))}
            </div>
            <div className="col-lg-4">
              <Skeleton height={40} style={{ marginBottom: "1rem" }} />
              <Skeleton count={3} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) return <p className="text-danger">Error: {error.message}</p>;

  return (
    <div className="faq-wrapper pt-110">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <Faq faqs={filtered} />
          </div>
          <div className="col-lg-4">
            <div className="faq-sidebar">
              <FaqSearch value={searchTerm} onChange={setSearchTerm} />
              <FaqTopic
                setSubjectFilter={setSubjectFilter}
                value={subjectFilter}
                onChange={setSubjectFilter}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqWrapper;
